$(window).on('load', function () {
  // Get the menu img elements
  $('nav.header-nav img').each(function () {
    // For each img, set the src attribute from the data attribute
    var headDataSrc = $(this).attr('data-src')
    if (headDataSrc) {
      $(this).attr('src', headDataSrc)
    }
  })
})
